import React, {useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTransactionData} from "../../hooks/useTransactionData";

import {
  Box,
  Button,
  Column,
  Columns,
  Control,
  Field,
  Modal,
  Pagination,
  Section,
  Table,
  Title,
} from "@allxsmith/bestax-bulma";

import {
  getDataFresh, getPaymentTypesData, getTrackingOptionsData, getDepartmentsData,
  getTransactionData, getNominalCodesData
} from "../../state/selectors";
import NewTransaction from "./NewTransaction";
import {
  formatDate,
  getLastDayOfWeek,
  getFirstDayOfWeek,
  expenseDueDate
} from "../../utils";
import useWeekInput from "../../hooks/useWeekInput";
import axios from "axios";
import {
  createSetDataFreshAction,
  createSetTransactionDataAction
} from "../../actions/dataActions";
import WeeklyTransactionView from "./WeeklyTransactionView";
import useSelect from "../../hooks/useSelect";
import TransactionRow from "./TransactionRow";
import {useReactToPrint} from "react-to-print";
import {ToastContainer, toast} from "react-toastify";
import PrintTransactions from "./PrintTransactions";
import FilterHeading from "../Invoicing/FilterHeading";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import MultipleEditModal from "./MultipleEditModal";

import SearchBar from "../Utils/SearchBar";
import {usePaymentTypesData} from "../../hooks/usePaymentTypesData";
import CreateCreditNoteModal from "../Credit Note/CreateCreditNoteModal";
import {useTrackingOptionsData} from "../../hooks/useTrackingOptionsData";
import LoadingSpinner from "../Utils/Spinner";
import useInput from "../../hooks/useInput";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import {useNominalCodesData} from "../../hooks/useNominalCodesData";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import FigureSummary from "../Figures/FigureSummary";
import Nav from "../Nav/Nav";
import PaginationWrapper from "../Utils/PaginationWrapper";
import {Col} from "reactstrap";

function Transactions(props) {
  const dispatch = useDispatch();
  const inout_mapping = {"OUT": "SP", "IN": "CC"};
  const locationMapping = {"/income": 'IN', "/expenses": 'OUT'}
  const componentRef = useRef();

  const handlePrint = useReactToPrint({contentRef: componentRef});


  const pathName = window.location.pathname;
  const view = locationMapping[pathName]


  const [page, setPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [filters, setFilters] = useState({});
  const [dateRange, setDateRange] = useState('all');
  const [creditModalOpen, setCreditModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState();
  const [searchFresh, setSearchFresh] = useState(1);
  const [selectedDepartment, setSelectedDepartment] = useState(-1);
  // const [view, viewInput] = useSelect({
  //   label: "View",
  //   initialValue: "IN",
  //   options: [
  //     {name: "Income", value: "IN"},
  //     {name: "Expense", value: "OUT"}
  //   ],
  //   testId: "part-view",
  //   callback: () => {
  //     setPage(1);
  //   }
  // });
  const [approved, approvedInput] = useSelect({
    label: "Approval Status",
    initialValue: "false",
    options: [
      {name: "Approved", value: "true"},
      {name: "Unapproved", value: "false"}
    ],
    testId: "part-approval",
    callback: () => {
      setPage(1);
    }
  });
  const [recurrentView, recurrentViewInput] = useSelect({
    label: "Recurring Transactions",
    initialValue: "false",
    options: [
      {name: "Shown", value: "false"},
      {name: "Hidden", value: "true"}
    ],
    callback: () => {
      setPage(1);
    }
  });

  const [date, dateInput] = useWeekInput({
    label: "Week Selection",
    initialValue: getFirstDayOfWeek(new Date()),
    weekly: true,
    disabled: dateRange === 'all'
  });

  const [dueDateStart, dueDateStartInput, setDueDateStart] = useInput({
    type:"date",
    label:"Due Date Start",
  });

  const [dueDateEnd, dueDateEndInput, setDueDateEnd] = useInput({
    type:"date",
    label:"Due Date End"
  });


  const dueDateFilter = (item) => {
    let dueDate = expenseDueDate(item, "invoice_date", "contact");
    let filterStart = new Date(dueDateStart);
    let filterEnd = new Date(dueDateEnd);
    if(dueDate >= filterStart && dueDate <= filterEnd){
      return true
    }
    return false
  }

  const selectDueDateFilter = () => {
    //check if expense
    if(view === "OUT") {
      if (dueDateStart && dueDateEnd) {
        let newSelected = {...selected};
        let filteredItems = data.results.filter((part) => dueDateFilter(part));
        filteredItems.forEach(item => {
          newSelected[item.id.toString()] = item;
        });

        setSelected(newSelected);
      } else {
        toast.warning("Please enter due date start and end", {position: "top-right"});
      }
    }
  }

  const dataFresh = useSelector(getDataFresh);


  let params = {
    page
  };

  if (currentSearch) {
    params.search = currentSearch;
  }
  if(selectedDepartment){
    params.department = selectedDepartment;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if (dateRange === 'weekly') {
    params.start_date = formatDate(new Date(date));
    params.finish_date = formatDate(getLastDayOfWeek(new Date(date)));
  }

  params.type = view;
  params.approved = approved;
  params.hiderecurring = recurrentView;

  const headings = [
    {
        label: "ID",
    },
    {
        label: "Date",
        field: "date",
        labelField: "date",
        date: true
    },
    {
        label: "Description"
    },
    {
        label: "Contact",
        field: "contact",
        labelField: "contact__display_name"
    },
    {
      label: "Department"
    },
    {
        label: "Tracking Category"
    },
    {
      label: "Payment Type",
      field: "payment_type",
      labelField: "payment_type__name",
      show: view === "OUT"
    },
    {
        label: "Customer Account",
        show: view === "IN"
    },
    {
      label: "Nominal Code",
      show: true
    },
    {
      label: "Amount (£)"
    },
    {
        label: "Invoice Date",
        field: "invoice_date",
        labelField: "invoice_date",
        date: true
    },
    {
        label: "Invoice Number",
        field: "invoice_number",
        labelField: "invoice_number"
    },
    {
        label: "Invoice Amount (£)"
    },
    {
        label: "Invoice VAT"
    },
    {
        label: "Invoice Total (£)",
    },
    {
      label: "Customer Paid",
      show: view === "IN"
    },
    {
      label: "Customer Payment Method",
      show: view === "IN"
    },
    {
      label: "Due Date",
      show: view === "OUT"
    },
    {
      label: "Remove From Figures",
      show: true
    },
    {
      label: "Comments"
    },
    {
      label: "Creator",
      field: "creator",
      labelField: "creator__first_name"
    }
  ];

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const complete = useTransactionData(
    params,
    dataFresh
  );
  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  const paymentTypeLoaded = usePaymentTypesData({}, dataFresh);
  const trackingOptionsLoaded = useTrackingOptionsData({page_size: 1000}, dataFresh);
  const nominalCodesLoaded = useNominalCodesData({page_size: 1000}, dataFresh);

  const toggleSelectVisible = () => {
    let newSelected = {...selected};
    let selectedKeys = Object.keys(newSelected);
    const notPresent = data.results.find(
      transaction => selectedKeys.indexOf(transaction.id.toString()) === -1
    );

    if (notPresent) {
      data.results.forEach(item => {
        newSelected[item.id.toString()] = item;
      });
    } else {
      data.results.forEach(item => {
        delete newSelected[item.id.toString()];
      });
    }
    setSelected(newSelected);
  };

  //const transaction_types_loaded = useTransactionCategoryData({});
  // const cost_centres_loaded = useCostCentreData({});

  const onSelectCheck = item => {
    let newSelection = {...selected};
    if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
      newSelection[item.id.toString()] = item;
    } else {
      delete newSelection[item.id.toString()];
    }
    setSelected(newSelection);
  };

  const clearSelected = () => {
    setSelected({});
  };

  const updateMultiple = newData => {
    newData.forEach(data => {
      data.approved = true;
    })
    const url = props.endpoint + "transactions/update";
    const conf = {
      method: "put",
      data: newData,
      url
    };

    return axios(conf)
  };

  const saveSelected = (invoiceDate, invoiceNumber, invoiceAmount, invoiceVAT, comments) => {
    const newData = Object.values(selected).map(item => {
      let toSave = {...item};
      if (invoiceDate) {
        toSave.invoice_date = invoiceDate;
      }
      if (invoiceNumber) {
        toSave.invoice_number = invoiceNumber;
      }
      if (invoiceAmount) {
        toSave.invoice_amount = invoiceAmount;
      }
      if (invoiceVAT) {
        toSave.invoice_vat = invoiceVAT;
      }
      if (comments) {
        toSave.comments = comments;
      }
      return toSave;
    });
    return updateMultiple(newData);
  };

  const approveSelected = () => {
    let passValidation = true;
    const newData = Object.values(selected).map(item => {
      if (item.invoice_number.length > 0 && (item.type === 'IN' ? /^\d+$/.test(item.invoice_number) : true)) {
        return {...item, approved: true};
      } else {
        passValidation = false;
        return {};
      }
    });

    if (passValidation) {
      return updateMultiple(newData);
    } else {
      toast.warning("You must specify an invoice number before approving!", {position: "top-right"});
    }
  };

  const onTransactionUpdate = (index, newTransaction) => {
    let newResults = [...data.results]
    let newState = {...data, results: newResults};
    newState.results[index] = newTransaction;
    dispatch(createSetTransactionDataAction(newState));
    setSelected({});
  };

  const handleDelete = id => {
    const endpoint = "/api/transactions/" + id;
    const conf = {method: "delete", url: endpoint};
    axios(conf).then(response =>
      dispatch(createSetDataFreshAction(dataFresh + 1))
    );
  };

  const onDepartmentChange = e => {
    setSelectedDepartment(e.target.value);
  };


  const data = useSelector(getTransactionData);
  const paymentTypes = useSelector(getPaymentTypesData);
  const departments = useSelector(getDepartmentsData);
  const trackingOptions = useSelector(getTrackingOptionsData);
  const nominalCodes = useSelector(getNominalCodesData);

  const nominalCodeObjects =  nominalCodes ? nominalCodes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  const trackingOptionObjects =  trackingOptions ? trackingOptions.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  const departmentObjects =  departments ? departments.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};


  if (!complete || !nominalCodesLoaded || !paymentTypeLoaded || !departmentsLoaded || !trackingOptionsLoaded) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner />
        </div>
    );
  }

  document.title = pathName[0].toUpperCase() + pathName.substring(1);

  // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <NewTransaction
          endpoint={props.endpoint}
          type={view}
          paymentTypes={paymentTypes}
          departments={departments}
          departmentObjects={departmentObjects}
          trackingOptions={trackingOptions}
          trackingOptionObjects={trackingOptionObjects}
          nominalCodes={nominalCodes}
          nominalObjects={nominalCodeObjects}
      />
      <WeeklyTransactionView endpoint={props.endpoint} type={view}/>
      <Box>
        <Title>Week View</Title>
        <Columns isMultiline>
          <Column>
            <Field className="has-addons">
              <Control>
                <label className="label">Date Range</label>
                <Button
                  color={dateRange === "all" ? "primary" : ""}
                  onClick={() => setDateRange("all")}
                >
                  All
                </Button>
                <Button
                  color={dateRange === "weekly" ? "primary" : ""}
                  onClick={() => setDateRange("weekly")}
                >
                  Weekly
                </Button>
              </Control>
            </Field>
          </Column>
          {dateInput}
          {approvedInput}
          {recurrentViewInput}
          <Column/>
        </Columns>
        <Columns isMultiline>
          <Column>
            <label className="label">Search for a Transaction</label>
           <SearchBar
            setSearchText={setSearchText}
            handleSearch={handleSearch}
            clear={clear}
            searchText={searchText}
           />
          </Column>
          <Column>
            <DepartmentSelector
              options={departments}
              value={selectedDepartment}
              onChange={onDepartmentChange}
              blank={true}
              editable={true}
              label={"Department"}
              name={"department"}
            />
          </Column>
          {view === "OUT" && dueDateStartInput}
          {view === "OUT" && dueDateEndInput}
          {view === "OUT" && (
          <Column>
            <label className="label">button</label>
            <Button
              color={"success"}
              onClick={selectDueDateFilter}
            >
              Select Filtered Expenses
            </Button>
          </Column>
          )}
        </Columns>
      </Box>
      <FigureSummary selectedDepartment={selectedDepartment}/>
      {/*<Box>*/}
      {/*  <Columns>*/}
      {/*    {summaryData.categories.map(cat => <TransactionsSummary category={cat} loaded={summaryComplete}*/}
      {/*                                                            hideExpense={view === 'IN'}*/}
      {/*                                                            hideIncome={view === 'OUT'}/>)}*/}
      {/*    {view === 'IN' &&*/}
      {/*    <Columns.Column>*/}
      {/*      <Form.Field>*/}
      {/*        <Form.Control>Total Income: £{summaryData.total_in.toFixed(2)}</Form.Control>*/}
      {/*      </Form.Field>*/}
      {/*    </Columns.Column>*/}
      {/*    }*/}
      {/*    {view === 'OUT' &&*/}
      {/*    <Columns.Column>*/}
      {/*      Total Expense: £{summaryData.total_out.toFixed(2)}*/}
      {/*    </Columns.Column>*/}
      {/*    }*/}
      {/*  </Columns>*/}
      {/*</Box>*/}
      <Box>
        <Title size="4">{view === 'IN' ? "Incoming" : "Outgoing"} Transactions {(departmentsLoaded && !!departmentObjects[selectedDepartment]) ? " - "+departmentObjects[selectedDepartment].name : ""}</Title>
        <Table>
          <thead>
          <tr>
            {headings.map(heading => {
              if(heading.show || heading.show === undefined) {
                if (!heading.field) {
                  return <th key={heading.label}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                      <FilterBlankHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                            setPage(1);
                            setFilters(f);
                          }}
                          filters={filters}
                      />
                  );
                }
                return (
                    <FilterHeading
                        key={heading.label}
                        heading={heading}
                        setFilters={f => {
                          setPage(1);
                          setFilters(f);
                        }}
                        filters={filters}
                        options={data.filter_list[heading.field]}
                    />
                );
              }
            })}
            {approved === 'true' && <th>Approver</th>}
            <th></th>
            <th>
              <Button
                onClick={toggleSelectVisible}
                color={
                  data.results.find(
                    transaction =>
                      Object.keys(selected).indexOf(transaction.id.toString()) === -1
                  )
                    ? ""
                    : "danger"
                }
              >
                {data.results.find(
                  transaction =>
                    Object.keys(selected).indexOf(transaction.id.toString()) === -1
                ) ? (
                  <div>
                    O
                    {/*<span>Visible</span>*/}
                  </div>
                ) : (
                  <div>
                    X
                    {/*<span>Visible</span>*/}
                  </div>
                )}
              </Button>
            </th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          {data.results.map((value, index) => (
            <TransactionRow
              key={value.id}
              transaction={value}
              index={index}
              onTransactionUpdate={onTransactionUpdate}
              endpoint={props.endpoint}
              onSelectCheck={onSelectCheck}
              selected={
                Object.keys(selected).indexOf(value.id.toString()) !== -1
              }
              clearSelected={clearSelected}
              editDisabled={approved === "true"}
              contact_type={inout_mapping[view]}
              paymentTypes={paymentTypes}
              view={view}
              departments={departments}
              departmentObjects={departmentObjects}
              setSelectedTransaction={setSelectedTransaction}
              setCreditModalOpen={setCreditModalOpen}
              trackingOptions={trackingOptions}
              trackingOptionObjects={trackingOptionObjects}
              approveMultiple={updateMultiple}
              nominalCodes={nominalCodes}
              nominalCodeObjects={nominalCodeObjects}
            />
          ))}
          </tbody>
        </Table>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        >
        </PaginationWrapper>
      </Box>
      <Box>
        <Columns isMultiline>
          <Column>
            <Button
              onClick={() => setEditModalOpen(true)}
              color={Object.entries(selected).length ? "primary" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Edit Selected
            </Button>
          </Column>
          <Column>
            <Button
              onClick={() => setModalOpen(true)}
              color={Object.entries(selected).length ? "warning" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Print Selected
            </Button>
          </Column>
          {approved === "false" && false &&
          <Column>
            <Button
              onClick={() => approveSelected()}
              color={Object.entries(selected).length ? "success" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Approve Selected
            </Button>
          </Column>
          }
        </Columns>
      </Box>
      <Modal closeOnBlur active={modalOpen} onClose={() => setModalOpen(false)}>
        <Modal.Content>
          <Section style={{backgroundColor: "white"}}>
            <Field>
              <p>
                You have selected {Object.keys(selected).length} out of total of{" "}
                {data.count} items for printing
              </p>
            </Field>
            <Columns>
              <Column>
                <Button
                  color={Object.entries(selected).length ? "success" : ""}
                  onClick={handlePrint}
                >
                  Print Selected
                </Button>
              </Column>
              <Column>
                <Button
                  color={"info"}
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </Button>
              </Column>
            </Columns>
          </Section>
        </Modal.Content>
      </Modal>
      <MultipleEditModal
        open={editModalOpen}
        setOpen={setEditModalOpen}
        selected={selected}
        saveSelected={saveSelected}
      />
      {selectedTransaction &&
        <CreateCreditNoteModal
          autoFill={{customer: selectedTransaction.contact, transaction: selectedTransaction}}
          endpoint={props.endpoint}
          dataFresh={dataFresh}
          open={creditModalOpen}
          setOpen={setCreditModalOpen}
        />
      }
      <div style={{display: "none"}}>
        <div ref={componentRef}>
          <PrintTransactions data={selected}/>
        </div>
      </div>
    </div>
  );
}

export default Transactions;
